import { getApiUrl } from './config';

/** Release management is hidden, so every request stays on the production line. */
const PRODUCTION_VERSION_ID = '00000000-0000-0000-0000-000000000000';
if (typeof localStorage !== 'undefined') {
  localStorage.setItem('activeVersionId', PRODUCTION_VERSION_ID);
  localStorage.setItem('activeVersionName', 'Production');
}

export async function apiFetch(url, options = {}) {
  const token = sessionStorage.getItem('token');
  const headers = { ...options.headers };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  headers['X-Version-Id'] = PRODUCTION_VERSION_ID;

  // Use the config to get the full URL
  let targetUrl = url;
  if (typeof url === 'string') {
    // If it's a relative path (doesn't start with http), use apiBase from config
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      targetUrl = getApiUrl(url);
    }
  }

  const response = await fetch(targetUrl, { ...options, headers });
  if (response.status === 401) {
    sessionStorage.removeItem('token');
    window.location.reload();
  }
  return response;
}
